import { v4 as uuidv4 } from 'uuid';
import eventBus from "@/event/event";
// import { showAlert } from "@/pages/Home";

function paramsToUrl(params) {
    let _url = ''
    for (const param in params) {
        _url += `${param}=${encodeURI(params[param])}&`
    }
    if (_url.length > 0) {
        return '?' + _url.substring(0, _url.lastIndexOf('&'))
    } else {
        return ''
    }
}

let uuid = window.localStorage.getItem('uuid');
if (!uuid) {
    uuid = uuidv4();
    window.localStorage.setItem('uuid', uuid);
}

export function http({
    baseUrl = process.env.REACT_APP_API_URL,
    url,
    method,
    query = {},
    body,
    headers = {},
    token = '',
}) {
    let _url = baseUrl + url + paramsToUrl(query)
    let timer = null

    return new Promise((resolve, reject) => {
        const _headers = { ...headers, 'x-device-id': uuid }
        let user = localStorage.getItem('userInfo') // old version
        let userToken = localStorage.getItem('userToken') // new version
        
        if (user && !userToken && !token) {
            user = JSON.parse(user)
            _headers['x-token'] = user.token
        }
        if (userToken) {
            _headers['x-token'] = userToken
        }
        if (token) {
            _headers['x-token'] = token
        }

        const fetchPromise = fetch(_url, {
            method,
            body: body && JSON.stringify(body),
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json',
                ..._headers,
            },
        })
            .then((res) => {
                if (!res || res?._contentType === "text/plain") {
                    throw new Error('服务器接口异常！')
                } else {
                    return res?.json()
                }
            })
            .then((res) => {
                if (res.status === 'ok') {
                    return res.data
                } else if (res?.code === 5001) { // 微信登录注册
                    return res
                } else if (res?.code === 5003) { // 发送验证码
                    return reject(res)
                } else {
                    reject(res?.err_msg || '服务异常！');
                    // alert && showAlert(res?.err_msg || '服务异常！');
                    if (res?.err_msg === '该账号已在其他设备登录' || res?.err_msg === '未登录') {
                        const searchParamsString = window.location.href.split('?')[1] || '';
                        const searchParams = new URLSearchParams(searchParamsString);
                        searchParams.delete('y');
                        eventBus.emit('logout', searchParams.toString());
                    }
                }
                
            })
            .catch((err) => {
                reject(err?.err_msg || err?.message || '网络异常！');
                // alert && showAlert(err?.err_msg || '网络异常！');
                // reject(null)
            })

        const specialTimeoutPromise = new Promise((_, rej) => {
            clearTimeout(timer)
            timer = setTimeout(() => {
                rej({name: 'timeout'})
            }, 300000)
        });

        const almostTimeoutPromise = new Promise((_, rej) => {
            clearTimeout(timer)
            timer = setTimeout(() => {
                rej({name: 'timeout'})
            }, 60000)
        });
        
        const arrayList = [
        ]

        const timeoutPromise = arrayList.includes(url) ? specialTimeoutPromise : almostTimeoutPromise 
        Promise.race([fetchPromise, timeoutPromise])
            .then(resolve)
            .catch(reject);
    })
}
